import { useRef } from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { RocketLaunch as RocketLaunchIcon } from '../../icons';
import { landingColors, landingFont } from '../landingTheme';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function CtaSection({ onNavigate, onScrollToSection }) {
  const sectionRef = useRef(null);
  useScrollReveal(sectionRef);

  return (
    <Box
      ref={sectionRef}
      component="section"
      aria-label="Get Started"
      sx={{ py: { xs: 9, md: 13 }, backgroundColor: landingColors.indigo, color: '#fff' }}
    >
      <Container maxWidth="md" sx={{ px: { xs: 2.5, md: 4 }, textAlign: 'center' }}>
        <Typography
          data-reveal
          component="h2"
          sx={{
            fontFamily: landingFont,
            fontWeight: 800,
            letterSpacing: '-0.02em',
            fontSize: { xs: '2rem', sm: '2.6rem', md: '3.2rem' },
            lineHeight: 1.08,
            mb: 2.5,
          }}
        >
          Ready to transform your restaurant?
        </Typography>
        <Typography
          data-reveal
          data-reveal-delay="0.08"
          sx={{ fontFamily: landingFont, fontSize: { xs: '1rem', md: '1.25rem' }, opacity: 0.92, maxWidth: 560, mx: 'auto', lineHeight: 1.6, mb: 4 }}
        >
          Join restaurants using merchQRy to serve customers faster, cut wait times, and grow their business.
        </Typography>
        <Box
          data-reveal
          data-reveal-delay="0.16"
          sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1.5, justifyContent: 'center', mb: 2.5 }}
        >
          <Button
            onClick={() => onNavigate('/register')}
            startIcon={<RocketLaunchIcon />}
            disableElevation
            sx={{
              fontFamily: landingFont,
              textTransform: 'none',
              fontWeight: 700,
              fontSize: '1.05rem',
              px: 4,
              py: 1.5,
              borderRadius: '14px',
              backgroundColor: '#fff',
              color: landingColors.indigo,
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)', transform: 'translateY(-2px)' },
              transition: 'transform 0.2s ease',
            }}
          >
            Start Your Free Trial
          </Button>
          <Button
            onClick={() => onScrollToSection('pricing-section')}
            variant="outlined"
            sx={{
              fontFamily: landingFont,
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '1.05rem',
              px: 4,
              py: 1.5,
              borderRadius: '14px',
              borderColor: 'rgba(255,255,255,0.5)',
              color: '#fff',
              '&:hover': { borderColor: '#fff', backgroundColor: 'rgba(255,255,255,0.12)' },
            }}
          >
            View Pricing
          </Button>
        </Box>
        <Typography data-reveal data-reveal-delay="0.2" sx={{ fontFamily: landingFont, fontSize: '0.85rem', opacity: 0.85, fontWeight: 500 }}>
          No credit card required &nbsp;•&nbsp; 14-day free trial &nbsp;•&nbsp; Cancel anytime
        </Typography>
      </Container>
    </Box>
  );
}
